import React, { Component } from "react";
import { ReduxConnect, Router } from "../../../../toolkit/decorators/Artifact";
import { Helmet } from "react-helmet";
import ProcesoSemestralComponent from "../../../components/comisionesAnualidad/procesoSemestral/ProcesoSemestral";
import {
  ProcesoSemestralStore,
  procesoSemestralStore
} from "./ProcesoSemestral.store";
import {
  ProcesoSemestralDispatcher,
  procesoSemestralDispatcher
} from "./ProcesoSemestral.dispatcher";
import Layout from "../../../components/layout";

interface Props extends ProcesoSemestralStore, ProcesoSemestralDispatcher {}
interface State {}

@Router()
@ReduxConnect(procesoSemestralStore, procesoSemestralDispatcher)
export default class ProcesoSemestralContainer extends Component<Props, State> {
  render() {
    return (
      <main>
        <Layout>
          <Helmet title="Proceso Semestral - Anualidades" />
          <ProcesoSemestralComponent {...this.props} />
        </Layout>
      </main>
    );
  }
}
